import React from 'react';
import PropTypes from 'prop-types';
import ContentText from 'Components/ContentText';
import Link from 'Components/Link';
import styles from './styles.scss';

const renderImprintData = () => {
  return (
    <div className={styles.textBlock}>
      <h2 className="h4">Verantwortliche Stelle 1:</h2>
      <address>
        <p>
          Mazda Motors (Deutschland) GmbH
          <br />
          Hitdorfer Straße 73
          <br />
          51371 Leverkusen
        </p>
        <p>
          Telefon: <Link to="tel:021739430" label="021739430" />
          <br />
          E-Mail: <Link to="mailto:info@mazda.de" label="info@mazda.de" />
        </p>
      </address>
      <p>
        Geschäftsführer: Bernhard Kaplan, Colin Maddocks, Giovanni Barbieri, Wojciech Halarewicz.
      </p>
      <p>Amtsgericht Köln, HRB 48377</p>
      <p>Ust-ID-Nr.: DE 1237 1888 0</p>
    </div>
  );
};

const Imprint = ({ wizard }) => {
  if (wizard) {
    return renderImprintData();
  }

  return (
    <ContentText>
      {renderImprintData()}
      <p className={styles.topSpacing}>
        Hinweis gemäß §36 Verbraucherstreitbeilegungsgesetz (VSBG):
        <br />
        Mazda Motors (Deutschland) GmbH wird nicht an einem Streitbeilegungsverfahren vor einer
        Universalschlichtungsstelle im Sinne des VSBG teilnehmen und ist hierzu auch nicht
        verpflichtet.
      </p>
    </ContentText>
  );
};

Imprint.propTypes = {
  wizard: PropTypes.bool,
};

export default Imprint;
